import api from "../api"

function parseApiData(value) {
	if (!value || !value.data) {
		throw new Error("Could not get response!")
	}
	if (value.data.error?.length > 0) {
		const error = new Error(value.data.error[0].message)
		error.code = value.data.error[0].code
		error.incidentID = value.data.error[0].incidentID
		throw error
	}
	return value.data.data
}

export default {
	async createCSR() {
		let value = await api.post(`csrassessments/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getSuppliers() {
		const value = await api.get(`/suppliers`)
		return parseApiData(value)
	},
	async getSupplierPerformanceOverview() {
		let value = await api.get(`/suppliers/performance`)
		if (!value?.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const data = value.data.data
		return Array.isArray(data) ? data : []
	},

	async getSuppliersByYearForConnections(year) {
		let value = await api.get(`/suppliersconnections/${year}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},

	async getSuppliersByYear(year) {
		let value = await api.get(`/suppliersbyyear/${year}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data1 = value.data.data
		return data1
	},
	async getSupplier(clientID) {
		let value = await api.get(`/suppliers/${clientID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		if (value?.data?.data?.length == 0) {
			return null
		}
		let data = value.data.data[0]
		return data
	},
	async getSuppliersWithoutCsr() {
		let value = await api.get(`csr-invite`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
}
